import { iframeDataBridge } from '@/iframe/iframeDataBridge';
import { authenticatedFetch, getApiUrl } from '@/utils/auth/authService';
import { log } from '@/utils/core/vueLogger.js';
import { CacheManager } from '@/utils/core/cacheManager.js';

const distributionChannelCache = new CacheManager('VueCache', 'cache', {
	maxAge: 24 * 60 * 60 * 1000,
	memoryCacheTTL: 30 * 60 * 1000,
	logCategory: 'DistributionChannel',
	keyPrefix: () => `${iframeDataBridge.getCustomer() ?? 'unknown'}.${iframeDataBridge.getCurrentUser()?.id ?? 'unknown'}.distributionChannels.`,
});

export async function getDistributionChannels(forceRefresh = false) {
	if (!forceRefresh && !distributionChannelCache.getFromMemory('all')) {
		try {
			const legacyData = await iframeDataBridge.getStorageAsync('DISTRIBUTIONCHANNELS');
			if (legacyData) {
				log('info', 'DistributionChannel', '📦 Seeding Vue cache from legacy storage (DISTRIBUTIONCHANNELS)');
				await distributionChannelCache.put('all', legacyData);
				distributionChannelCache.setInMemory('all', legacyData);
				return legacyData;
			}
		} catch (legacyError) {
			log('warn', 'DistributionChannel', `⚠️ Legacy storage check failed: ${legacyError.message}`);
		}
	}

	return distributionChannelCache.fetchOrCache('all', fetchDistributionChannelsFromAPI, { forceRefresh, fallback: [], backgroundRefresh: true });
}

async function fetchDistributionChannelsFromAPI() {
	const response = await authenticatedFetch(getApiUrl('Sales/DistributionChannels'), { method: 'GET' }, 'tokenSales');
	if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

	const distributionChannels = await response.json();
	log('success', 'DistributionChannel', `✅ Fetched ${distributionChannels.length} distribution channels`);
	return distributionChannels;
}

export async function refreshDistributionChannels() {
	distributionChannelCache.clearMemory();
	await distributionChannelCache.clear();
}
